import { twMerge } from "tailwind-merge";

type HorizontalLineProps = {
  className?: string;
};

const HorizontalLine = ({ className }: HorizontalLineProps) => {
  return <div className={twMerge("bg-gray-100 w-full h-px", className)} />;
};

export default HorizontalLine;
